

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadNewsletterNotifications
// GETUNREADNEWSLETTERNOTIFICATIONS   

const GETUNREADNEWSLETTERNOTIFICATIONS= createAsyncThunk(
  "getUnreadNewsletterNotifications/getUnreadNewsletterNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadNewsletterNotificationsSlice = createSlice({
  name: "getUnreadNewsletterNotificationsSlice",
  initialState: {
    getUnreadNewsletterNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadNewsletterNotifications: (state) => {
        state.getUnreadNewsletterNotifications.loading = false
        state.getUnreadNewsletterNotifications.error = false
        state.getUnreadNewsletterNotifications.data = []
        state.getUnreadNewsletterNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADNEWSLETTERNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadNewsletterNotifications = {
        ...state.getUnreadNewsletterNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADNEWSLETTERNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadNewsletterNotifications = {
        ...state.getUnreadNewsletterNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADNEWSLETTERNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadNewsletterNotifications = {
        ...state.getUnreadNewsletterNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadNewsletterNotificationsAction = {
    GETUNREADNEWSLETTERNOTIFICATIONS,
};

export { getUnreadNewsletterNotificationsAction };
export default getUnreadNewsletterNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadNewsletterNotifications} = getUnreadNewsletterNotificationsSlice.actions